import {
  PRE_SELECTED_FILTERS,
  PRE_SELECTED_ADVANCED_FILTERS,
} from '@alumni_v2/data/preSelectedFilter';

export default function setPreSelectedFilters(filters) {
  window.sessionStorage.setItem(
    PRE_SELECTED_FILTERS,
    JSON.stringify(filters),
  );
}

export function setPreSelectedAdvancedFilters(filters) {
  window.sessionStorage.setItem(
    PRE_SELECTED_ADVANCED_FILTERS,
    JSON.stringify(filters),
  );
}

export function clearPreSelectedFilters() {
  window.sessionStorage.removeItem(PRE_SELECTED_FILTERS);
  window.sessionStorage.removeItem(PRE_SELECTED_ADVANCED_FILTERS);
}
